import { MessageErrorComponent } from '@klickdata/core/message/src/message-error/message-error.component';
import { ChangeDetectionStrategy, Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { ContentCollectionService, ContentCollection } from '@klickdata/core/content-collection';
import { MessageSavedComponent, MessageService } from '@klickdata/core/message';
import { AppScope } from '@klickdata/core/resource';
import { ObjectValidator } from 'apps/klickdata/src/app/shared/validator/object.validator';
import { of, Subject } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { Utils } from '@klickdata/core/util';

@Component({
    selector: 'app-content-collection-bottom-sheet',
    templateUrl: './content-collection-bottom-sheet.component.html',
    styleUrls: ['./content-collection-bottom-sheet.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentCollectionBottomSheetComponent implements OnInit, OnDestroy {
    public saving: Subject<boolean> = new Subject<boolean>();
    public destroy: Subject<boolean> = new Subject<boolean>();
    AppScope = AppScope;
    public contentCollectionForm: FormGroup;
    Utils = Utils;
    constructor(
        public bottomSheetRef: MatBottomSheetRef<ContentCollectionBottomSheetComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
        protected fb: FormBuilder,
        protected contentCollectionService: ContentCollectionService,
        protected message: MessageService
    ) {
        this.contentCollectionForm = this.fb.group({
            id: [],
            sync_all: [],
            attach_ids: [[]],
            detach_ids: [[]],
            title_translation: [{}, ObjectValidator.validTranslation],
        });
    }

    ngOnInit(): void {
        if (this.data.contentCollection) {
            this.contentCollectionForm.patchValue({
                id: this.data.contentCollection.id,
                title_translation: this.data.contentCollection.title_translation,
            });
        }
    }
    submit() {
        this.saving.next(true);
        const data = new ContentCollection(this.contentCollectionForm.value).getData();
        data.scope_id = this.data.scope;
        data.public = true;
        const createOrUpdate = !data.id
            ? this.contentCollectionService.addContentCollection(data)
            : this.contentCollectionService.updateContentCollection(data);

        createOrUpdate
            .pipe(
                takeUntil(this.destroy),
                catchError((err) => {
                    if (err && err.error && err.error.error) {
                        this.message.openMessage(MessageErrorComponent, err.error.error.messages);
                    }
                    return of(null);
                })
            )
            .subscribe((contentCollection) => {
                this.saving.next(false);
                this.message.openMessage(MessageSavedComponent);
                this.bottomSheetRef.dismiss(contentCollection);
            });
    }
    ngOnDestroy(): void {
        this.destroy.next(true);
        this.destroy.unsubscribe();
    }
}
